import { USER_VIP_REQUEST, USER_VXU_REQUEST, USER_OPEN_REQUEST, USER_VXU_OPEN_REQUEST } from '../mutations_type.js'
import { USER_VIP_API, USER_OPEN_API, USER_VXU_API, USER_VXU_OPEN_API } from '../../services/api/api.js'
import axios from 'axios'

const header = {
  headers: {
    Authorization: 'Bearer ' + localStorage.getItem('token'),
  },
}

const state = {
  userVips: [],
  userVxu: [],
  userOpens: [],
  userVxuOpen: [],
}

const getters = {
  USER_VIP: state => {
    return state.userVips
  },
  USER_VXU: state => {
    return state.userVxu
  },
  USER_OPEN: state => {
    return state.userOpens
  },
  USER_VXU_OPEN: state => {
    return state.userVxuOpen
  },
}

const mutations = {
  [USER_VIP_REQUEST]: (state, payload) => {
    state.userVips = payload
  },
  [USER_OPEN_REQUEST]: (state, payload) => {
    state.userOpens = payload
  },
  [USER_VXU_REQUEST]: (state, payload) => {
    state.userVxu = payload
  },
  [USER_VXU_OPEN_REQUEST]: (state, payload) => {
    state.userVxuOpen = payload
  },
}

const actions = {
  [USER_VIP_REQUEST]: ({ commit }) => {
    axios
      .get(
        USER_VIP_API.replace('{game_id}', localStorage.getItem('game_id')),
        header
      )
      .then(response => {
        const data = response.data
        const userVips = data.data
        if (data.code === 0 && userVips) {
          commit('USER_VIP_REQUEST', userVips)
        }
      })
  },
  [USER_OPEN_REQUEST]: ({ commit }) => {
    axios
      .get(
        USER_OPEN_API.replace('{game_id}', localStorage.getItem('game_id')),
        header
      )
      .then(response => {
        const data = response.data
        const userOpens = data.data
        if (data.code === 0 && userOpens) {
          commit('USER_OPEN_REQUEST', userOpens)
        }
      })
  },
  [USER_VXU_REQUEST]: ({ commit }) => {
    axios
      .get(
        USER_VXU_API.replace('{game_id}', localStorage.getItem('game_id')),
        header
      )
      .then(response => {
        const data = response.data
        const userVxu = data.data
        if (data.code === 0 && userVxu) {
          commit('USER_VXU_REQUEST', userVxu)
        }
      })
  },
  [USER_VXU_OPEN_REQUEST]: ({ commit }) => {
    axios
      .get(
        USER_VXU_OPEN_API.replace('{game_id}', localStorage.getItem('game_id')),
        header
      )
      .then(response => {
        const data = response.data
        const userVxuOpen = data.data
        if (data.code === 0 && userVxuOpen) {
          commit('USER_VXU_OPEN_REQUEST', userVxuOpen)
        }
      })
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
